import { PublicClientApplication } from '@azure/msal-browser';
import { getMsalConfig } from './authConfig';

/**
 * Single PublicClientApplication for the app. Streaming and API code must use this
 * instance so tokens and cache match the account used after login/redirect.
 */
export const msalInstance = new PublicClientApplication(getMsalConfig());
